<template>
  <div>
    <top-navbar></top-navbar>

    <div class="background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3">
          <i class="fa fa-angle-right" aria-hidden="true"></i>
        </span>
        Service
        <span class="pfimg3">
          <i class="fa fa-angle-right" aria-hidden="true"></i>
        </span>
        <router-link class="decoration" to="/mcustomer/index">
          Manage Service Schedule
        </router-link>
      </h6>

      <div class="calendar-wrapper">
        <div class="calendar-container">
          <!-- Navigation Buttons -->
         <button  class="side-btn left background_color2" @click="prevMonth">
            <i  class="fa fa-chevron-left pe-1 "></i>
          </button>
          <button  class="side-btn right background_color2" @click="nextMonth">
            <i  class="fa fa-chevron-right"></i>
          </button>

          <!-- Month Header -->
          <div class="week-picker-box">
            <div class="month-title">
              {{ monthTitle }}
            </div>
            <input
              type="date"
              v-model="selectedDate"
              @change="updateMonth"
              class="date-input"
            />
          </div>

          <!-- Monthly Calendar Grid -->
          <div class="month-grid">
            <div
              v-for="(day, index) in monthDays"
              :key="index"
              :class="['day-column', { today: isToday(day) }]"
              @click="day && openModal(day)"
            >
              <div v-if="day" class="day-cell">
                <div class="day-header">
                  <div class="day-title">{{ formatDay(day) }}</div>
                  <div class="day-date">
                    <span class="day-number">{{ day.getDate() }}</span>
                  </div>
                </div>

                <div class="events-list">
                  <div
                    v-for="event in events[day.toDateString()]"
                    :key="event._id"
                    class="event-card"
                    :style="{
                      backgroundColor:
                        event.job_category === 'repair_job'
                          ? '#2ecc71'
                          : event.job_category === 'preventive_job'
                          ? '#f5d938'
                          : ''
                    }"
                    @click.stop="openEventModal(event)"
                  >
                    <div class="event-line event-line-primary">
                      {{ event.p_code || "-" }}
                    </div>
                    <div class="event-line">
                      {{ event.description || "-" }}
                    </div>
                    <div class="event-line">
                      {{ event.remark || "-" }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="empty-day"></div>
            </div>
          </div>

          <!-- Modal Section -->
          <div v-if="showModal" class="modal">
            <div class="modal-content">
              <span class="close" @click="closeModal">&times;</span>
              <h3>{{ selectedDate ? selectedDate.toDateString() : "" }}</h3>

              <div v-if="editingEvent">
                <label class="custom-label">Booking Number</label>
                <input class="form-control" v-model="all_data.id" disabled />
              </div>

               <label class="custom-label" >Job Category</label>
              <v-select class="boder-set"
                label="label"
               @input="jobcategory()"
                v-model="category"
                :options="cats"
              ></v-select>
               <div v-if="sheduleShow">
               <label class="custom-label">Date Scheduled</label>
              <v-select class="boder-set"
                label="label"
               @input="scheduledate()"
                v-model="dateshedule"
                :options="shedules"
              ></v-select>
              </div>
              <div v-if="sheduleDate">
                <label class="custom-label">Scheduled Date</label>
                <input  class="form-control boder-set" type="date" v-model="all_data.sheduledate"  />
              </div>


              <label class="custom-label">Asset Code</label>
              <v-select class="boder-set"
                label="label"
                @input="loadDelar"
                v-model="all_data.p_code"
                :options="inventrs"
              ></v-select>
              <label class="custom-label">Asset Description</label>
              <v-select class="boder-set"
                label="label"
                @input="loadDelar2"
                v-model="all_data.description"
                :options="inventrs2"
              ></v-select>

           

              <div v-if="editingEvent">
                <label class="custom-label">Date</label>
                <input class="form-control boder-set" type="date" v-model="all_data.date" />
              </div>

             

              <label class="custom-label">Remarks</label>
              <textarea class="form-control boder-set" v-model="all_data.remark"></textarea>

              <button v-if="editingEvent" @click="updateEvent">Update</button>
              <button v-if="editingEvent" @click="createJob">Create Job</button>
              <button v-else @click="saveEvent">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br /><br /><br /><br />
    <content-footer></content-footer>
  </div>
</template>


<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from "axios";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  name: "WeeklyCalendar",
  components: {
    TopNavbar,
    ContentFooter,
    "v-select": vSelect,
  },
  data() {
  return {
    currentWeekStart: this.getStartOfWeek(new Date()),
    currentMonthDate: new Date(),
    selectedWeek: 0,
    weekOptions: [],
    shedules: [
      {'label':'Not Scheduled', 'value':0},
      {'label':'Scheduled Date', 'value':1,}
    ],
    dateshedule:'',

    today: new Date(),  // make sure it's initialized
    events: {},
    showModal: false,
    sheduleDate: false,
    sheduleShow: false,
 selectedDate: this.formatInputDate(new Date()), // default today
    weekRangeDisplay: "",
    editingEvent: null,
    engin_chasi: {},
    category: {},
    inventrs: [],
    inventrs2: [],
    cats: [
      {'label':'Repair Job','value':'repair_job'},
      {'label':'Preventive Job','value':'preventive_job'},
     
    ],
    all_data: {
      modelname: "",
      user_full_name: "",
      user_contact_tel1: "",
      remark: "",
    },
    eventType: "default",
  };
  },
  computed: {
    monthTitle() {
      const date = new Date(this.currentMonthDate);
      return date.toLocaleDateString("en-US", {
        month: "long",
        year: "numeric",
      });
    },
    monthDays() {
      const start = new Date(this.currentMonthDate);
      start.setDate(1);

      const firstDay = start.getDay();
      const daysInMonth = new Date(
        start.getFullYear(),
        start.getMonth() + 1,
        0
      ).getDate();

      const days = [];
      for (let i = 0; i < firstDay; i++) {
        days.push(null);
      }

      for (let d = 1; d <= daysInMonth; d++) {
        const date = new Date(start);
        date.setDate(d);
        days.push(date);
      }

      return days;
    },
      todayFormatted() {
    const options = { weekday: "long", month: "short", day: "numeric", year: "numeric" };
    return this.today.toLocaleDateString("en-US", options);
  },
  
    weekDays() {
      const start = new Date(this.currentWeekStart);
      return Array.from({ length: 7 }, (_, i) => {
        const d = new Date(start);
        d.setDate(start.getDate() + i);
        return d;
      });
    },
    weekRange() {
      const start = this.weekDays[0];
      const end = this.weekDays[6];
      const options = { month: "short", day: "numeric" };
      return `${start.toLocaleDateString("en-US", options)} - ${end.toLocaleDateString(
        "en-US",
        options
      )}`;
    },
  },
  mounted() {
   
     this.updateMonth();

    this.loadData();
  },
  methods: {
    isToday(date) {
      if (!date) return false;

      const today = new Date();
      return (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
      );
    },
    formatInputDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    updateMonth() {
      if (!this.selectedDate) return;

      const date = new Date(this.selectedDate);
      this.currentMonthDate = new Date(date.getFullYear(), date.getMonth(), 1);
      this.fetchEvents();
    },

    scheduledate(){
      if(this.dateshedule.value=='0'){
        this.sheduleDate = false;
      }else if(this.dateshedule.value=='1'){
        this.sheduleDate = true;
      }
    },
    jobcategory(){
      if(this.category.value=='preventive_job'){
        this.sheduleDate = true;
      }else if(this.category.value=='repair_job'){
        this.sheduleDate = false;
        this.sheduleShow = true;
      }
    },

   updateWeekRange() {
  if (!this.selectedDate) return;

  const date = new Date(this.selectedDate);
  const day = date.getDay();
  const diffToMonday = day === 0 ? -6 : 1 - day; // Monday start
  const monday = new Date(date);
  monday.setDate(date.getDate() + diffToMonday);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  // update display text
  const options = { month: "short", day: "numeric", year: "numeric" };
  this.weekRangeDisplay = `${monday.toLocaleDateString("en-US", options)} - ${sunday.toLocaleDateString("en-US", options)}`;

  // 🔹 update the calendar to show this week
  this.currentWeekStart = monday;

  // 🔹 reload events for that week
  this.fetchEvents();
},

 



     formatMonth(date) {
    return date.toLocaleDateString("en-US", { month: "short" }); // e.g., "Oct"
  },
    getStartOfWeek(date) {
      const day = date.getDay();
      const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Monday start
      return new Date(date.setDate(diff));
    },
nextMonth() {
  const next = new Date(this.currentMonthDate);
  next.setMonth(next.getMonth() + 1);
  this.currentMonthDate = next;
  this.selectedDate = this.formatInputDate(next);
  this.fetchEvents();
},
prevMonth() {
  const prev = new Date(this.currentMonthDate);
  prev.setMonth(prev.getMonth() - 1);
  this.currentMonthDate = prev;
  this.selectedDate = this.formatInputDate(prev);
  this.fetchEvents();
},
nextWeek() {
  const next = new Date(this.currentWeekStart);
  next.setDate(next.getDate() + 7);
  this.currentWeekStart = next;
  this.selectedDate = this.formatInputDate(next); // keep sync
  this.updateWeekRange();
  this.fetchEvents();
},
prevWeek() {
  const prev = new Date(this.currentWeekStart);
  prev.setDate(prev.getDate() - 7);
  this.currentWeekStart = prev;
  this.selectedDate = this.formatInputDate(prev); // keep sync
  this.updateWeekRange();
  this.fetchEvents();
},
    formatDay(date) {
      return date.toLocaleDateString("en-US", { weekday: "short" });
    },
    formatDate(date) {
      return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
    },

    openModal(date) {
      this.selectedDate = date;
      this.showModal = true;
      this.editingEvent = null;
      this.clearFormData();
    },
    openEventModal(event) {
      this.selectedDate = new Date(event.scheduled_date || event.date);
      this.engin_chasi = event.engin_chasi;
      this.all_data = { ...event };
      this.editingEvent = event;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.editingEvent = null;
      this.clearFormData();
    },

    async createJob() {
      const event = { id: this.all_data.id };
      this.$router.push("/servicejob/create?id=" + event.id);
    },

     async saveEvent() {
      try {
        const event = {
          id:this.all_data.id,
          p_code:this.all_data.p_code,
          description:this.all_data.description,
        
          category: this.category,
          dateshedule: this.dateshedule,
          sheduledate: this.all_data.sheduledate,
      
          remark: this.all_data.remark,
        
          type: this.eventType,
          date: this.selectedDate.toLocaleDateString('en-CA')
        };

        const { data } = await axios.post('/cserviceevent/create', { event: event }, {
          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          }
        });
        console.log(data);
        if (data.status == 200) {
          this.fetchEvents();
          this.clearFormData();
        }

        this.closeModal();
      } catch (error) {
        console.error('Error saving event:', error);
      }
    },

    async updateEvent() {
      try {
        const event = {
          ...this.all_data,
          engin_chasi: this.engin_chasi,
        };
        const { data } = await axios.post(
          "/serviceevent/update",
          { event },
          {
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-type": "application/json",
            },
          }
        );
        if (data.status == 200) {
          this.fetchEvents();
          this.closeModal();
        }
      } catch (error) {
        console.error("Error updating event:", error);
      }
    },

    async fetchEvents() {
    console.log("test event");
      try {
        const response = await axios.get(
          "/cserviceevent/index",
          {
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-type": "application/json",
            },
          }
        );
        const fetchedEvents = response.data.events.reduce((acc, event) => {
          const dateKey = new Date(event.scheduled_date).toDateString();
          if (!acc[dateKey]) acc[dateKey] = [];
          acc[dateKey].push(event);
          return acc;
        }, {});
        console.log(response.data);
        this.events = fetchedEvents;
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    },

    async loadData() {
      try {
        const { data } = await axios.post(
          "/cserviceevent/loaddata",
          {},
          {
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-type": "application/json",
            },
          }
        );
        this.inventrs = data.inventrs;
        this.inventrs2 = data.inventrs2;
      } catch (error) {
        console.error(error);
      }
    },

    async loadDelar() {
      try {
        const { data } = await axios.post(
          "/cserviceevent/loaddelar",
          { p_code: this.all_data.p_code,description: this.all_data.description,sheduledate:this.all_data.sheduledate },
          {
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-type": "application/json",
            },
          }
        );
        console.log(data);
        this.all_data = data.all_data;
      } catch (error) {
        console.error(error);
      }
    },
    async loadDelar2() {
      try {
        const { data } = await axios.post(
          "/cserviceevent/loaddelar2",
          { description: this.all_data.description,sheduledate:this.all_data.sheduledate },
          {
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-type": "application/json",
            },
          }
        );
        console.log(data);
        this.all_data = data.all_data;
      } catch (error) {
        console.error(error);
      }
    },

    clearFormData() {
      this.all_data = {
        modelname: "",
        user_full_name: "",
        user_contact_tel1: "",
        remark: "",
        id: "",
      };
      this.engin_chasi = null;
    },
  },
};
</script>

<style scoped>
.calendar-wrapper {
  position: relative;
}

.calendar-container {
  position: relative;
  padding: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

/* Calendar Title */
.calendar-header-text {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  padding: 8px;
}

/* Week Navigation Buttons */
.side-btn {
  position: absolute;
  top: 14px;
  transform: none;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  z-index: 2;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0;
  padding: 0;
}
.side-btn.left {
  left: 45px;
}
.side-btn.right {
  right: 45px;
}

/* Month Grid Layout */
.month-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-auto-rows: 112px;
  gap: 10px;
  padding: 10px;
}

/* Each Day Column */
.day-column {
  background: #ffffff;
  border: 1px solid #d9e1f2;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;
  min-height: 96px;
  overflow: hidden;
  padding: 6px;
  cursor: pointer;
}
.day-column:hover {
  transform: translateY(-3px);
}

.day-cell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

/* Day Heading (Top Box) */
.day-header-box {
  background-color: #007bff;
  color: #fff;
  text-align: center;
  padding: 10px 0;
  border-radius: 8px;
}

.day-date {
  font-size: 12px;
  opacity: 0.9;
}

/* Small space between heading and event box */
.space-between {
  height: 8px;
}

/* Event Box (Middle Box) */
.event-box {
  background-color: #f7faff;
  flex-grow: 1;
  border-radius: 8px;
  padding: 8px;
  overflow-y: auto;
  border: 1px solid #e1e8f5;
}

/* Event Card Style */
.event-card {
 
  color: white;
  padding: 4px 6px;
  border-radius: 6px;
  margin-bottom: 5px;
  text-align: left;
  font-size: 10px;
  line-height: 1.15;
  cursor: pointer;
  transition: background 0.3s ease;
  overflow: hidden;
}
/* .event-card:hover {
  background: #0056b3;
} */

/* Add Event Button (Bottom, separate box) */
.add-event-btn {
  text-align: center;
  font-size: 13px;
  color: #007bff;
  font-weight: bold;
  cursor: pointer;
  border: 1px dashed #007bff;
  border-radius: 6px;
  padding: 6px;
  margin-top: 10px;
  transition: background 0.2s ease;
}
.add-event-btn:hover {
  background: #eaf2ff;
}

/* Modal (Popup) */
.modal {
  position: fixed;
  z-index: 1050;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 100%;
  max-width: 400px;
}
.close {
  color: #aaa;
  float: right;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
}

/* Buttons inside modal */
button {
  margin-top: 10px;
  padding: 6px 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  width: 100%;
}
button:hover {
  background-color: #0056b3;
}

/* Label Styling */
.custom-label {
  font-size: small;
}
.datenumb{
   font-size: 30px;      /* Adjust size as needed */
  font-weight: bold;
  text-align: center;
  
}
.day-header {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  flex-shrink: 0;
  margin-bottom: 2px;
}

.day-title {
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}


.month-number {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.month {
  font-size: 14px;       /* smaller month on top of number */
  color: #555;
  margin-bottom: 2px;
}

.day-number {
  font-size: 20px;
  font-weight: bold;
  color: #007bff;
  line-height: 1;
}
.events-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-top: 2px;
}
.event-line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.event-line + .event-line {
  margin-top: 2px;
}
.event-line-primary {
  font-weight: 700;
}
.day-name {
  text-align: center;
  font-weight: bold;
  margin-bottom: 0px;
  padding-bottom: 0px;/* remove any extra top margin */
}
.week-select-box {
  display: flex;
  align-items: center;
  justify-content: center; /* center horizontally */
  gap: 8px; /* space between label and select */
  margin: 0 auto; /* center inside parent container */
  text-align: center;
}

.week-select-box label {
  font-weight: bold;
}

.week-select-box select {
  padding: 3px 6px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.week-picker-box {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.date-input {
  padding: 6px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.week-display {
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: #f9f9f9;
  width: 250px;
  text-align: center;
}
.month-title {
  min-width: 180px;
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: #f9f9f9;
  text-align: center;
  font-weight: 700;
}
.today {
  border: 2px solid #007bff;
  background: #eaf3ff;
}
.boder-set{
  margin-top: -7px;
  margin-bottom: 7px;
}

</style>
